import {cssTheme} from '@logistics-frontend/blocks'
import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const classes = {
  actionWrapper: css`
    margin: ${spacing(0, 1)};
    width: ${spacing(7)};
    text-align: center;
  `,
  action: css`
    width: 56px;
    height: 56px;
    overflow: hidden;
    position: relative;
    cursor: pointer;
    border-radius: 50%;
    background: center no-repeat ${cssTheme.colors.warmGray[125]};
    background-size: ${spacing(4)};
    margin: ${spacing(0, 'auto', 1)};
    transition: background-color 0.2s ease;
    border: none;
    display: block;
  `,
}
